import React, { Component, Fragment } from 'react';
import Dropdown from './dropdown';
import { connect } from "react-redux";
import { Link } from 'react-router-dom'
import { navigateTo } from 'actions/routerActions';
import { getLeftNavData } from "../../actions/menubarAction";
import configHelper from 'helper/Config/configHelper';
import MenuBar from '@tgslabs/npm-menubar/build/';
import APP from 'app';
import { analysisPublish } from '@tgslabs/clevertap-analysis';

const { redirectionDomains, redirectionConfig } = APP.Utils.getConfig();
const { translateData, getDefaultRouteForRole } = APP.Utils;

const {
    redirectionDomains: _redirectionDomains = redirectionDomains,
} = APP.Utils.fetchGlobal();
class MainMenu extends Component {
    constructor() {
        super();
        this.renderList = this.renderList.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        //Commenting since we are not showing dropdown for dashboard
        this.props.getLeftNavData();
    }

    handleClick = link => {
        navigateTo(link);
    }

    renderList = () => {
        const { submenu = {}, getMenubar = [], userId = '', userinfos = {} } = this.props,
            { userInfo = {} } = userinfos,
            { tt = '' } = userInfo;
        const menuData = translateData(getMenubar, 'Menubar');
        return (
            <MenuBar
                userMenu={getDefaultRouteForRole(redirectionConfig, menuData)}
                currHost={'HOTEL'}
                submenu={submenu}
                redirectionDomains={_redirectionDomains}
                userId={userId}
                tt={tt}
                userInfo={userInfo}
                analysisPublish={analysisPublish}
            />
        );
    }

    render() {
        return (
            <Fragment>
                {this.renderList()}
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getLeftNavData: () => {
        dispatch(getLeftNavData());
    }
});


const mapStateToProps = state => {
    const { menubarList = {}, userinfos = {} } = state;
    const { userInfo: userData = {} } = userinfos;
    const { userId = '' } = userData;
    const { submenu = {} } = menubarList;
    return {
        ...state,
        submenu,
        userId
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
